import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_InlineAlert = _resolveComponent("InlineAlert")
  const _component_Button = _resolveComponent("Button")
  const _component_CardFooter = _resolveComponent("CardFooter")
  const _component_Form = _resolveComponent("Form")
  const _component_SettingsLayout = _resolveComponent("SettingsLayout")

  return (_openBlock(), _createBlock(_component_SettingsLayout, {
    title: "Profile Information",
    description: "Update your account's profile information and email address."
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Form, {
        valid: _ctx.valid,
        "onUpdate:valid": _cache[6] || (_cache[6] = $event => (_ctx.valid = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Input, {
            label: "First Name",
            rules: _ctx.form.first_name.rules,
            value: _ctx.form.first_name.value,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => (_ctx.form.first_name.value = $event))
          }, null, 8, ["rules", "value"]),
          _createVNode(_component_Input, {
            label: "Last Name",
            rules: _ctx.form.last_name.rules,
            value: _ctx.form.last_name.value,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => (_ctx.form.last_name.value = $event))
          }, null, 8, ["rules", "value"]),
          _createVNode(_component_Input, {
            label: "Email",
            rules: _ctx.form.email.rules,
            value: _ctx.form.email.value,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => (_ctx.form.email.value = $event))
          }, null, 8, ["rules", "value"]),
          _createVNode(_component_CardFooter, {
            class: "flex flex-row justify-end items-center",
            style: {"padding-right":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InlineAlert, {
                show: _ctx.showAlert,
                "onUpdate:show": _cache[4] || (_cache[4] = $event => (_ctx.showAlert = $event)),
                "is-success": _ctx.isSuccess
              }, null, 8, ["show", "is-success"]),
              _createVNode(_component_Button, {
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.handleSave())),
                color: "secondary",
                "is-disabled": !_ctx.valid
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["is-disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["valid"])
    ]),
    _: 1
  }))
}